import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class AddressTypeService {
   async getAddressTypes() {
      return await http.get('/company-address-types', cacheFirstConfig).then((response) => response.data?.data || []);
   }
}
